__webpack_require__.p = "/akal/";